import Empty from 'general/components/Empty'
import ProtectedRoute from 'general/components/Routes/ProtectedRoute'
import AppResource from 'general/constants/AppResource'
import { Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Navigate, Route, Routes } from 'react-router-dom'
import ListErrorAnnouncement from './screens/ListErrorAnnouncement'
import { useEffect } from 'react'
import ListReplacedInvoice from 'features/HandleInvoice/screens/ListReplacedInvoice'
import ListReplaceAccountingDocument from 'features/HandleInvoice/screens/ListReplaceAccountingDocument'
import ListAdjustedInvoice from 'features/HandleInvoice/screens/ListAdjustedInvoice'
import ListAdjustAccountingDocument from 'features/HandleInvoice/screens/ListAdjustAccountingDocument'
HandleDocument.propTypes = {}

function HandleDocument() {
  const { t } = useTranslation()
  useEffect(() => {}, [])
  return (
    <Routes>
      <Route path="" element={<Navigate to="thong-bao-lap-sai" />} />
      <Route
        path={'thong-bao-lap-sai'}
        element={
          <ProtectedRoute permission={true}>
            <ListErrorAnnouncement currentTab={0} />
          </ProtectedRoute>
        }
      />
      <Route
        path={'thong-bao-chung-tu-da-lap-thong-bao'}
        element={
          <ProtectedRoute permission={true}>
            <ListErrorAnnouncement currentTab={1} />
          </ProtectedRoute>
        }
      />
      <Route
        path={'thong-bao-chung-tu-chua-lap-thong-bao'}
        element={
          <ProtectedRoute permission={true}>
            <ListErrorAnnouncement currentTab={2} />
          </ProtectedRoute>
        }
      />
      <Route path={'/thay-the'} element={<ListReplaceAccountingDocument />} />
      <Route path={'/dieu-chinh'} element={<ListAdjustAccountingDocument />} />
      <Route
        path="*"
        element={
          <Container fluid className="h-100 d-flex">
            <Row className="justify-content-center align-items-center flex-grow-1">
              <Empty
                text={t('PageNotFound')}
                buttonText={t('Refresh')}
                visible={false}
                imageEmpty={AppResource.icons.icEmptyBox}
              />
            </Row>
          </Container>
        }
      />
    </Routes>
  )
}

export default HandleDocument
